import { createAction, props } from '@ngrx/store';
import { TaskDto } from '../../../shared/components/tasks/task/task';

export const loadAllTasks = createAction('[Task] Load Tasks', props<{ locationId: number }>());

export const setAllTasks = createAction('[Task] Load Tasks Success', props<{ tasks: TaskDto[] }>());

export const updateTask = createAction('[Task] Update task success', props<{ task: TaskDto }>());
